import reducer from './reducer';

export default reducer;
export {
  getTipsState,
  tipClick,
  activeTipClick,
  inactiveTipClick,
  skipSlide,
  viewSlide,
  closeShareModal,
  openFundsModal,
  closeFundsModal,
  modifyTarget,
  moreAboutFees,
  getPageViews,
  getShares,
  getDonations,
  uploadProfilePhoto,
} from './actions';



// WEBPACK FOOTER //
// ./src/redux/modules/dashboard/index.js